import BaseController from "controllers/base"
import FilterForm from "widgets/filterForm";

class Controller extends BaseController {
  call() {
    super.call();

    bindFilterFormWidget.call(this)
  }
};

var bindFilterFormWidget = function() {
  let elem = this.root.find("#filter-form");
  this.filterForm = new FilterForm(elem);
}

export default Controller;
